import _ from 'underscore';

export const modelToViewModelForCallToActionSettings = (model, isAudienceMMACTADefaultOptOutEnabled) => {
  const isOptOut = _.result(_.find(
    _.get(model, 'CampaignSettings', []),
    setting => setting['@odata.type'] === '#Model.CallToActionSetting'
  ), 'CallToActionOptOut', !!isAudienceMMACTADefaultOptOutEnabled);

  return {
    IsCallToActionOptOut: isOptOut,
  };
};
